export default __webpack_public_path__ + "static/media/team100.70863fae.JPG";